import AdSense from "react-adsense";
import { useRouteMatch } from "react-router-dom";
// import UUID from "../Utils/uuid";
import ErrorBoundary from "../Components/ErrorBoundaries";

const Header = () => {
  const { params } = useRouteMatch();
  const { problemUrl } = params;
  return (
    <ErrorBoundary>
      <AdSense.Google
        client="ca-pub-5281236737710443"
        slot="3507651626"
        style={{ display: "block" }}
        format="auto"
        responsive="true"
        key={`${problemUrl}`}
      />
    </ErrorBoundary>
  );
};

export default Header;
